
import Select from '@/ui-kit/components/select';
import { FilterCommonEventType } from '../enums';
import { StyleFillType } from '@/ui-kit/components/input/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';

export default {
  name: 'FilterChartType',
  components: {
    Select,
  },
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
    fillType: {
      default: StyleFillType.Underlined,
      type: String,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    labelColorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    options: {
      default: () => [],
      type: Array,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit(FilterCommonEventType.Change, value);
    },
  },
};
